import createSimpleValidator from './createSimpleValidator';

const errorString = 'Vous devez entrer un numéro de téléphone valide (10 chiffres).';
const checkIsPhoneNumber = createSimpleValidator(
    (value) => value && /^[0-9]{10}$/.test(value.replace(/ /g, '')),
    errorString,
);

export default checkIsPhoneNumber;
